<div class="container">
  <!-- Header -->
  <div class="header d-flex">
    <h2 class="h2" i18n>Sitemate Links Accessed</h2>
    <a (click)="onClose()" class="ml-auto fa fa-close"></a>
  </div>

  <!-- Links display table -->
  <table class="table sitemate-form-table">
    <thead>
      <tr>
        <th>Link Name</th>
        <th *ngIf="displayFolder">Folder</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let link of assignedUser.taskUrls">
        <td>{{ link.taskName }}</td>
        <td *ngIf="displayFolder">{{ link.hierarchy }}</td>
      </tr>
    </tbody>
  </table>
</div>
